import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const STOREFRONT_SYSTEM_ACTOR_ID = "00000000-0000-4000-8000-000000000001" as Uuid;

export enum CustomerProfileStatus {
    active = "4d2dbae7-3095-4d88-8498-ae5ff21357f5",
    deleted = "fe955465-f99b-4b6c-a1e3-f5af064c314d",
}

export enum AddressStatus {
    active = "a3b8c9d0-1e2f-4a5b-8c9d-0e1f2a3b4c5d",
    archived = "b4c9d0e1-2f3a-4b5c-9d0e-1f2a3b4c5d6e",
}

export enum AddressType {
    billing = "597caa21-5c6f-4bac-999a-3cf804b0352f",
    shipping = "c32a626b-ecf6-41c1-981f-de5d0c163454",
}

export enum ProfileAdditionalColumnType {
    email = "7a27ffb5-ef3d-4165-aae3-e04bb8259430",
    indianPhoneNumber = "80edaaf6-3873-42bc-a18d-cd587999a2c7",
    text = "a0b66d48-33e5-4f31-9657-fb5b09403d55",
}

export enum ProfileAdditionalColumnField {
    fullName = "4c40cb91-71af-40b7-b316-3bfb250286f9",
    companyName = "6e62ed13-93c0-62d9-d538-5dfd4724a081",
}
